import onlyFullField from './onlyFullField';
import axios from 'axios';

const request = async (url, method = 'GET', data, headers) => {
  const authToken = localStorage.getItem('widgetToken');

  let response = null;

  try {
    if (method === 'GET' || method === 'get' || !data) {
      response = await axios({
        method,
        url,
        headers: {
          ...onlyFullField(headers),
          Authorization: `Bearer ${authToken}`,
        },
      });
    } else {
      response = await axios({
        method,
        url,
        data,
        headers: {
          ...onlyFullField(headers),
          Authorization: `Bearer ${authToken}`,
        },
      });
    }

    const responseData = await response.data;

    if (responseData.Success) {
      return responseData.Data;
    }

    return responseData;
  } catch (e) {
    const status = e.response && e.response.status;
    const body = (e.response && e.response.data) || {};
    const error = new Error(body.ClientReadableExceptionMessage || body.ExceptionMessage ||
      (url.split('/').pop() === 'signin' && status === 400
        ? 'Неверный логин или пароль'
        : 'Произошла ошибка, попробуйте позже или обратитесь в техподдержку'));
    error.status = status;
    error.code = body.ExceptionMessage;
    error.clientMessage = body.ClientReadableExceptionMessage;
    throw error;
  }
};

export default request;
